module.exports = __webpack_public_path__ + "media/src/img/payment/visa_mastercard-5e051ac6f387fb15fec345ff75cd9940.svg";